import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_RECURRINGTICKETS } from "../../../utils/constants";
import { TicketInterface } from "../../../models/TicketModule/Ticket";
import ticketService from "../../../services/ticketService/ticketService";

interface DeleteTicketContext {
  previousTickets: TicketInterface[];
  deletedTicket: TicketInterface | undefined;
}

const useDeleteRecTicket = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    void, // No return data after deletion
    Error,
    string, // ID of the ticket to delete
    DeleteTicketContext
  >({
    mutationFn: ticketService.Remove, // Remove should take a string ID

    onMutate: (ticketId: string) => {
      const previousTickets =
        queryClient.getQueryData<TicketInterface[]>([
          CACHE_KEY_RECURRINGTICKETS,
          page,
          pageSize,
        ]) || [];

      // Optimistically update the cache
      queryClient.setQueryData<TicketInterface[]>(
        [CACHE_KEY_RECURRINGTICKETS, page, pageSize],
        previousTickets.filter((ticket) => ticket.id !== ticketId) // Use ticketId to filter
      );

      return {
        previousTickets,
        deletedTicket: previousTickets.find((ticket) => ticket.id === ticketId),
      };
    },

    onError: (error, ticketId, context) => {
      if (!context) return;

      // Rollback to the previous state in case of error
      queryClient.setQueryData<TicketInterface[]>(
        [CACHE_KEY_RECURRINGTICKETS, page, pageSize],
        context.previousTickets
      );
    },

    onSuccess: () => {
      // Optionally, you could perform additional actions on success
      // For example, invalidating queries or updating other parts of the state
    },
  });
};

export default useDeleteRecTicket;
